import React from "react";
import "./page-utilisateur-anonymise.scss";

// Fiche d'un allocataire anonymisé (§ 13.2 de la spec) : plus aucun contenu,
// à l'image d'une page 404 — une icône et un libellé, rien d'autre. Rendu à
// la fois en page pleine et dans la modale (RecipientDetail s'arrête ici).
const PageUtilisateurAnonymise = () => (
  <div className="page-utilisateur-anonymise" role="status">
    <i className="fa fa-user-secret page-utilisateur-anonymise__icon" aria-hidden="true" />
    <p className="page-utilisateur-anonymise__label">Utilisateur anonymisé</p>
  </div>
);

export default PageUtilisateurAnonymise;
